import { Injectable } from '@angular/core';
import {API_TYPE, HttpHelperService} from "../../../services/http-helper.service";
import {
  CommonService,
  SESSION_KEY_ADMIN_SRCH_PERSON_OWNERSHIPS,
  SESSION_KEY_ADMIN_SRCH_PERSON_POA_DATA,
  SESSION_KEY_ADMIN_SRCH_PERSON_POA_OWNERSHIP_DATA,
  SESSION_KEY_AUTH_ACCOUNT, SESSION_KEY_AUTH_OWNERSHIPS,
  SESSION_KEY_AUTH_POA_DATA,
  SESSION_KEY_AUTH_POA_OWNERSHIPS
} from "./common.service";
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class OwnershipService {

  constructor( private httpHelper: HttpHelperService,
               private datePipe: DatePipe,
               private commonService: CommonService
  ) { }

  getUserOwnerships() {
    return this.httpHelper.get('GetUserOwnerships', {}, API_TYPE.OWNERSHIP_API);
  }

  getUserPoAOwnerships() {
    return this.httpHelper.get('GetUserPoAOwnerships', {}, API_TYPE.OWNERSHIP_API);
  }

  getOwnershipsForPersonNumber(personNumber:any) {
    return this.httpHelper.get('GetOwnershipsForPersonNumber', {personNumber}, API_TYPE.OWNERSHIP_API);
  }

  setOwnerships(data: any){
    if (data) {
      sessionStorage.setItem(SESSION_KEY_ADMIN_SRCH_PERSON_OWNERSHIPS, JSON.stringify(data));
    }
  }

  setAdminSearchPersonPoaData(data: any, refPersonNo: any){
    sessionStorage.setItem(SESSION_KEY_ADMIN_SRCH_PERSON_POA_DATA, JSON.stringify(data));
    // -- GETTING
    if(data.globalPowerOfAttorneyRoles){
      let allOwnerships = [];
      const poaOwnerships: any = this.getPoaOwnershipsFromData(data.globalPowerOfAttorneyRoles, refPersonNo);
      const poaOwnershipsLcl: any = this.getPoaOwnershipsFromData(data.localPowerOfAttorneyRoles, refPersonNo);
      if(poaOwnerships.length){
        allOwnerships = poaOwnerships;
      }
      if(poaOwnershipsLcl.length){
        allOwnerships = allOwnerships.concat(poaOwnershipsLcl);

      }
      if(allOwnerships.length){
        sessionStorage.setItem(SESSION_KEY_ADMIN_SRCH_PERSON_POA_OWNERSHIP_DATA, JSON.stringify(allOwnerships));
      }

    }
  }

  getPoaOwnershipsFromData(data: any, refPersonNo: any){
    const ownershipsArr: any = [];
    if(Array.isArray(data) && data.length){
      data.forEach((item: any) => {
        const poaInfo: any = {
          assignedDateTime: item.assignedDateTime,
          customerInfo: item.customerInfo
        }
        if(Array.isArray(item.ownerships) && item.ownerships.length){
          item.ownerships.forEach((ownItem: any) => {
            const addressData = ownItem.propertyUnitDetails.address;
            ownItem['title'] = this.commonService.getFormattedAddress(addressData);
            ownItem['ref_person_number'] =  refPersonNo;
            ownItem['ownership_start_date'] = ownItem['startDate']? this.datePipe.transform(ownItem['startDate'], 'yyyy-MM-dd') : '';
            ownItem.poaInfo = poaInfo;
            ownershipsArr.push(ownItem);
          })
        }
      })
    }
    return ownershipsArr;
  }

  getOwnershipFromSessionByid(ownershipId: any){
    const sessOwnerships: any = this.getOwnerships();
    let matchOwnership: any;
    if(Array.isArray(sessOwnerships)){
      sessOwnerships.forEach((item: any) => {
        if(item.ownershipId && item.ownershipId == ownershipId){
          matchOwnership = item;
        }
      })
    }
    return matchOwnership;
  }

  getOwnerships() {
    let parsedAuthData: any;
    const sessOwnerships = sessionStorage.getItem(SESSION_KEY_ADMIN_SRCH_PERSON_OWNERSHIPS);
    if (sessOwnerships) {
      parsedAuthData = JSON.parse(sessOwnerships);
    }
    return parsedAuthData;
  }

  getAdminSrchPersonhOwnerships() {
    let parsedAuthData: any = [];
    let parsedAuthPoaData: any = [];
    const srchPersonData = sessionStorage.getItem(SESSION_KEY_ADMIN_SRCH_PERSON_OWNERSHIPS);
    const srchPersonPoaData = sessionStorage.getItem(SESSION_KEY_ADMIN_SRCH_PERSON_POA_OWNERSHIP_DATA);
    if (srchPersonData) {
      parsedAuthData = JSON.parse(srchPersonData);
    }
    if (srchPersonPoaData) {
      parsedAuthPoaData = JSON.parse(srchPersonPoaData);
      parsedAuthPoaData.forEach((item: any) => {
        item.isPoaItem = true;
        parsedAuthData.push(item);
      })
    }
    return parsedAuthData.length ? parsedAuthData : null ;
  }


}
